module.exports = __webpack_public_path__ + "static/media/avi.b16ba842.png";